import { useQuery } from "@tanstack/react-query";
import { application } from "../application/application";
import { parseGraphQLResponse } from "../utils/apiMaper";

export const useBaseQuery = <TData = any>(
  queryKey: (string | number | boolean)[],
  operation: string,
  variables?: any,
  options?: {
    enabled?: boolean;
    staleTime?: number;
    retry?: boolean;
    refetchOnWindowFocus?: boolean;
    microapp?: string;
    isSingle?: boolean;
  },
) => {
  return useQuery<TData>({
    queryKey,
    enabled: options?.enabled ?? true,
    staleTime: options?.staleTime ?? 1000 * 60 * 15,
    retry: options?.retry ?? false,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
    queryFn: async () => {
      const response = await application.network.fetch(operation, variables, options?.microapp);
      return parseGraphQLResponse(response as any, options?.isSingle ?? false) as TData;
    },
  });
};
